module.exports = __webpack_public_path__ + "static/media/acc2.c6fc20ad.jpg";